<template>
  <fieldset>
    <div class="form-row">
      <div
        v-if="roleFeatures.showExcludeInactiveCenters"
        class="form-group col-md-4"
      >
        <DerToggleWithLabel
          v-model="excludeInactiveCenters"
          :label="trans('admin.exports.excludeInactiveCenters')"
          :input-id="excludeInactiveCentersInputId"
        />
      </div>
      <div
        v-if="roleFeatures.showExcludeCentersWithTestInName"
        class="form-group col-md-4"
      >
        <DerToggleWithLabel
          v-model="excludeCentersWithTestInName"
          :label="trans('admin.exports.excludeCentersWithTestInName')"
          :input-id="excludeCentersWithTestInNameInputId"
        />
      </div>
      <div
        v-if="roleFeatures.showExcludeTestPatients"
        class="form-group col-md-4"
      >
        <DerToggleWithLabel
          v-model="excludeTestPatients"
          :label="trans('admin.exports.excludeTestPatients')"
          :input-id="excludeTestPatientsInputId"
        />
      </div>
    </div>
  </fieldset>
</template>
<script setup>
import { inject, ref, watchEffect } from "vue";
import DerToggleWithLabel from "../../../../../../design-system/DerToggleWithLabel.vue";
import { v4 as uuidV4 } from "uuid";
import {
  useExportFormField,
  EXPORT_ROLE_FEATURES_KEY,
} from "./useExportFormField";

const roleFeatures = inject(EXPORT_ROLE_FEATURES_KEY, {
  showExcludeInactiveCenters: false,
  showExcludeCentersWithTestInName: false,
  showExcludeTestPatients: false,
});

const excludeInactiveCenters = ref(false);
const excludeCentersWithTestInName = ref(false);
const excludeTestPatients = ref(false);

const excludeInactiveCentersInputId = uuidV4();
const excludeCentersWithTestInNameInputId = uuidV4();
const excludeTestPatientsInputId = uuidV4();

watchEffect(() => {
  const features =
    typeof roleFeatures === "object" && "value" in roleFeatures
      ? roleFeatures.value
      : roleFeatures;
  excludeInactiveCenters.value = !!features.showExcludeInactiveCenters;
  excludeCentersWithTestInName.value =
    !!features.showExcludeCentersWithTestInName;
  excludeTestPatients.value = !!features.showExcludeTestPatients;
});

useExportFormField({
  excludeInactiveCenters,
  excludeCentersWithTestInName,
  excludeTestPatients,
});
</script>
